/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_radar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste metrics and values to build a radar (spider) chart that compares several items across many dimensions at once. Each row is a metric; each numeric column is an item plotted as its own polygon.`)
};

const es_radar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega métricas y valores para crear un gráfico de radar (araña) que compara varios elementos en muchas dimensiones a la vez. Cada fila es una métrica; cada columna numérica es un elemento graficado como su propio polígono.`)
};

const de_radar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie Kennzahlen und Werte ein, um ein Radar-(Spinnen-)Diagramm zu erstellen, das mehrere Elemente über viele Dimensionen gleichzeitig vergleicht. Jede Zeile ist eine Kennzahl; jede numerische Spalte ist ein Element, das als eigenes Polygon dargestellt wird.`)
};

const nl_radar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak metrics en waarden om een radar- (spider-) diagram te bouwen dat meerdere items tegelijk over veel dimensies vergelijkt. Elke rij is een metric; elke numerieke kolom is een item, getekend als eigen veelhoek.`)
};

const fr_radar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez des métriques et des valeurs pour créer un diagramme radar (en araignée) qui compare plusieurs éléments selon de nombreuses dimensions à la fois. Chaque ligne est une métrique ; chaque colonne numérique est un élément tracé comme son propre polygone.`)
};

const it_radar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla metriche e valori per costruire un grafico radar (a ragno) che confronta più elementi su molte dimensioni contemporaneamente. Ogni riga è una metrica; ogni colonna numerica è un elemento tracciato come proprio poligono.`)
};

const pt_br2_radar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole métricas e valores para criar um gráfico de radar (aranha) que compara vários itens em muitas dimensões ao mesmo tempo. Cada linha é uma métrica; cada coluna numérica é um item plotado como seu próprio polígono.`)
};

const pt_radar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole métricas e valores para construir um gráfico radar (aranha) que compara vários itens em muitas dimensões ao mesmo tempo. Cada linha é uma métrica; cada coluna numérica é um item representado como o seu próprio polígono.`)
};

const ja_radar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指標と値を貼り付けると、複数の項目を多くの次元にわたって一度に比較するレーダー（スパイダー）チャートが作成されます。各行が1つの指標で、各数値列が1つの項目を表す多角形としてプロットされます。`)
};

const zh_radar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴指标和数值以构建雷达图（蜘蛛图），在多个维度上一次性比较多个项目。每行是一个指标；每个数值列是一个以多边形绘制的项目。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const radar_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.radar_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("radar_intro", locale)
	if (locale === "en") return en_radar_intro(inputs)
	if (locale === "es") return es_radar_intro(inputs)
	if (locale === "de") return de_radar_intro(inputs)
	if (locale === "nl") return nl_radar_intro(inputs)
	if (locale === "fr") return fr_radar_intro(inputs)
	if (locale === "it") return it_radar_intro(inputs)
	if (locale === "pt-BR") return pt_br2_radar_intro(inputs)
	if (locale === "pt") return pt_radar_intro(inputs)
	if (locale === "ja") return ja_radar_intro(inputs)
	return zh_radar_intro(inputs)
};